<template>
  <div class="query-nav" @mouseenter="hovered = true" @mouseleave="hovered = false">
    <transition name="query-nav-fade">
      <div v-show="hovered" class="query-nav__panel">
        <div class="query-nav__panel-title">Queries in this chat</div>
        <button
          v-for="(q, i) in queries"
          :key="q.id"
          type="button"
          class="query-nav__item"
          :title="q.text"
          @click="$emit('navigate', q.id)"
        >
          <span class="query-nav__num">{{ i + 1 }}</span>
          <span class="query-nav__text">{{ q.text }}</span>
        </button>
      </div>
    </transition>

    <div class="query-nav__ticks" aria-hidden="false">
      <button
        v-for="(q, i) in queries"
        :key="q.id"
        type="button"
        class="query-nav__tick"
        :aria-label="`Go to query ${i + 1}`"
        :title="q.text"
        @click="$emit('navigate', q.id)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TraceyAiQueryNav',
  props: {
    /** [{ id, text }] — one per user query in the active chat. */
    queries: { type: Array, default: () => [] },
  },
  data() {
    return { hovered: false };
  },
};
</script>

<style scoped>
.query-nav {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 10px;
}

.query-nav__ticks {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 7px;
  padding: 8px 2px;
}

.query-nav__tick {
  width: 20px;
  height: 4px;
  border-radius: 2px;
  background: #ff1463;
  opacity: 0.55;
  cursor: pointer;
  transition: opacity 0.15s ease, width 0.15s ease, background-color 0.15s ease;
}

.query-nav__tick:hover {
  width: 28px;
  opacity: 1;
}

.query-nav__panel {
  max-width: 300px;
  max-height: 60vh;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e6ecf3;
  border-radius: 12px;
  box-shadow: 0 6px 28px rgba(18, 37, 58, 0.18);
  padding: 8px;
}

.query-nav__panel-title {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8e8ea0;
  padding: 4px 8px 6px;
}

.query-nav__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  text-align: left;
  padding: 8px;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.query-nav__item:hover {
  background: #f2f4f7;
}

.query-nav__num {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #12253a;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.query-nav__text {
  flex: 1;
  min-width: 0;
  font-size: 12.5px;
  line-height: 1.35;
  color: #353740;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.query-nav-fade-enter-active,
.query-nav-fade-leave-active {
  transition: opacity 0.12s ease;
}

.query-nav-fade-enter,
.query-nav-fade-leave-to {
  opacity: 0;
}
</style>
